function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.8676,
  cy: 26.6804,
  rx: 26.8676,
  ry: 26.0298,
  fill: "#63AE00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7515 19.5877H18.3835C20.2075 19.5877 21.8155 19.9397 23.2075 20.6437C24.6155 21.3317 25.7035 22.3077 26.4715 23.5717C27.2555 24.8357 27.6475 26.3077 27.6475 27.9877C27.6475 29.6677 27.2555 31.1397 26.4715 32.4037C25.7035 33.6677 24.6155 34.6517 23.2075 35.3557C21.8155 36.0437 20.2075 36.3877 18.3835 36.3877H10.7515V19.5877ZM18.1915 33.1957C19.8715 33.1957 21.2075 32.7317 22.1995 31.8037C23.2075 30.8597 23.7115 29.5877 23.7115 27.9877C23.7115 26.3877 23.2075 25.1237 22.1995 24.1957C21.2075 23.2517 19.8715 22.7797 18.1915 22.7797H14.6395V33.1957H18.1915ZM34.4676 22.7077V27.1477H42.2436V30.2677H34.4676V36.3877H30.5796V19.5877H43.2756V22.7077H34.4676Z",
  fill: "white"
});

function SvgDairyFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairyFree);
export default __webpack_public_path__ + "static/media/dairy-free.e9328c89.svg";
export { ForwardRef as ReactComponent };